import { useState, type ImgHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface LoadingImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc?: string;
  containerClassName?: string;
}

const FALLBACK = "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?q=80&w=2070";

const LoadingImage = ({
  src,
  alt,
  className,
  containerClassName,
  fallbackSrc = FALLBACK,
  ...props
}: LoadingImageProps) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  return (
    <div className={cn("relative overflow-hidden", containerClassName)}>
      {/* Shimmer placeholder */}
      {!loaded && (
        <div className="absolute inset-0 img-loading" />
      )}

      <img
        src={error ? fallbackSrc : src}
        alt={alt}
        className={cn(
          className,
          "transition-opacity duration-500",
          loaded ? "opacity-100" : "opacity-0"
        )}
        onLoad={() => setLoaded(true)}
        onError={() => {
          if (!error) {
            setError(true);
            setLoaded(false);
          } else {
            setLoaded(true);
          }
        }}
        {...props}
      />
    </div>
  );
};

export default LoadingImage;
